import { render, staticRenderFns } from "./ConferenceConfigLegacy.vue?vue&type=template&id=3bee403c&scoped=true&"
import script from "./ConferenceConfigLegacy.vue?vue&type=script&lang=js&"
export * from "./ConferenceConfigLegacy.vue?vue&type=script&lang=js&"
import style0 from "./ConferenceConfigLegacy.vue?vue&type=style&index=0&id=3bee403c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bee403c",
  null
  
)

export default component.exports